var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CatPreviewLocation',{staticClass:"page-view-map h-screen w-screen ios-touch-scroll",attrs:{"latitude":_vm.latitude,"longitude":_vm.longitude}})}
var staticRenderFns = []

export { render, staticRenderFns }